import App, {Tool} from '../App';
import Api from './Api';
import Resource from '../Resource';
import {NormRequest, SectionNormRequest} from './NormRequest';

class EmerRequest {
    static data(props) {
        App.log('EMER_REQUEST.DATA', App.LOG.FETCH, props);

        const body = {
            sectionRequestId: props.sectionRequestId
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.DATA, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve({...result.objList[0]?.sectionEmgRequestFormVM, ...result.objList[0]?.requestInfo});
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.GET_FAILED);
            });
        });
    }

    static delete(props) {
        App.log('EMER_REQUEST.DELETE', 'Referring to other method');

        return NormRequest.delete(props);
    }
}

class SectionEmerRequest extends EmerRequest {
    static insert(props) {
        App.log('SECTION_EMER_REQUEST.INSERT', App.LOG.FETCH, props);

        const body = {
            sectionEmgRequestVM: {
                patientFirstName: props?.patientFirstName,
                patientLastName: props?.patientLastName,
                patientFatherName: props?.patientFatherName,
                patientBirthDate: props?.patientBirthDate,
                patientNationalCode: props?.patientNationalCode,
                patientGenderId: props?.patientGenderId,
                patientProvinceId: parseInt(props?.patientProvinceId),
                patientCityId: parseInt(props?.patientCityId),
                sectionId: parseInt(props?.sectionId),
                patientFileCode: props?.patientFileCode,
                patientFileCodeId: props?.patientFileCodeId,
                bloodSampleSend: props?.bloodSampleSend,
                emergencyRequestReasonStr: props?.emergencyRequestReasonStr,
                bloodBankInform: props?.bloodBankInform,
                needCrossMatch: props?.needCrossMatch,
                rbcCount: props?.rbcCount,
                wbCount: props?.wbCount,
                docterId: props?.docterId,
                withoutCrossMatch: props?.withoutCrossMatch,
                withoutRH: props?.withoutRH
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.EMER.INSERT, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve(result.objList[0]);
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.INSERT_FAILED);
            });
        });
    }

    static list() {
        App.log('SECTION_EMER_REQUEST.LIST', 'Referring to other method');

        return SectionNormRequest.list();
    }

    static update(props) {
        App.log('SECTION_EMER_REQUEST.UPDATE', App.LOG.FETCH, props);

        const body = {
            sectionEmgRequestVM: {
                sectionEmgRequestId: props.sectionEmgRequestId,
                sectionId: props.sectionId,
                patientFileCodeId: props.patientFileCodeId,
                bloodSampleSend: props.bloodSampleSend,
                emergencyRequestReasonStr: props.emergencyRequestReasonStr,
                bloodBankInform: props.bloodBankInform,
                needCrossMatch: props.needCrossMatch,
                rbcCount: props.rbcCount,
                wbCount: props.wbCount,
                docterId: props.docterId,
                withoutCrossMatch: props.withoutCrossMatch,
                withoutRH: props.withoutRH
            }
        };

        return new Promise((resolve, reject) => {
            fetch(Api.REQUEST.SECTION.EMER.UPDATE, {
                body: JSON.stringify(body),
                method: Tool.METHODS.POST,
                headers: Tool.headers()
            }).then(response => {
                Tool.response(response, {
                    '200:0': result => {
                        resolve();
                    },
                    'default': result => {
                        reject(result.resultMessage);
                    }
                });
            }).catch(_ => {
                reject(Resource.STRING.FETCH.UPDATE_FAILED);
            });
        });
    }
}

export {SectionEmerRequest};